import { IconX } from "@tabler/icons-react";
import { Link } from "react-router";

const CategoryModal = (props: any) => {
    return (
        <>
            <div className="modal fade" id="modal-menu">
                <div className="modal-dialog modal-dialog-scrollable modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header align-items-center justify-content-between">
                            <h6 className="card-title mb-0">
                                انتخاب دسته بندی
                            </h6>
                            <button className="bg-white border-0 p-0" id="close-modal">
                                <IconX data-bs-dismiss="modal" className="font-medium" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="accordion" id="accordionExample">
                                {props.parentCategory?.map((category: any, index: number) => (
                                    <div className="accordion-item">
                                        <h2 className="accordion-header bg-white" id="headingOne">
                                            <button className={index === 0 ? 'accordion-button bg-white fw-bold shadow-none' : 'accordion-button fw-bold bg-white shadow-none collapsed'} type="button" data-bs-toggle="collapse" data-bs-target={`#category-collapse${category.id}`} aria-expanded="true" aria-controls="collapseOne">
                                                {category.name}
                                            </button>
                                        </h2>
                                        <div id={`category-collapse${category.id}`} className={index === 0 ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div className="accordion-body py-2 pb-3">
                                                <ul className="px-0 list-group">
                                                    {props.childCategory?.map((item: any) => (
                                                        <>
                                                            {item.parent_id === category.id ? (
                                                                <>
                                                                    <li className="list-group-item">
                                                                        <Link to={'#'} onClick={() => props.handleNavigate(item.slug)} data-bs-dismiss="modal" className="text-decoration-none text-dark">
                                                                            {item.name}
                                                                        </Link>
                                                                    </li>
                                                                </>
                                                            ) : null}
                                                        </>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CategoryModal;